import { H_REFERENCIAL_MAT_TYPES } from 'account/constants/AccessRulesConstants'
import FixedSlideNav from 'components/navbar/FixedSlideNav'
import BoundaryError from 'log/components/BoundaryError'
import PropTypes from 'prop-types'
import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { Outlet, useParams } from 'react-router-dom'
import ReferencialAction from 'referencial/action/ReferencialAction'
import { REFERENCIAL_TYPE_NAME } from 'referencial/constants/ReferencialConstants'
import i18n from 'simple-react-i18n'
import { componentHasHabilitations } from 'utils/HabilitationUtil'

const MatTypeRouterApp = () => {
    const dispatch = useDispatch()
    const { code, field } = useParams()

    const navLinks = useMemo(() => {
        return [{
            icons: 'dashboard',
            name: i18n.dashboard,
            href: `/referencial/${REFERENCIAL_TYPE_NAME.materielType}/${field}/${code}/dashboard`,
            habilitation: H_REFERENCIAL_MAT_TYPES,
        }].filter(l => componentHasHabilitations(l.habilitation))
    }, [code, field])

    useEffect(() => {
        dispatch(ReferencialAction.fetchMaterielTypes())
    }, [dispatch])

    return (
        <div className='row no-margin'>
            <FixedSlideNav links={navLinks} />
            <main>
                <div className='row no-margin padding-left-1'>
                    <div className='content-page no-padding fullscreen'>
                        <BoundaryError>
                            <Outlet />
                        </BoundaryError>
                    </div>
                </div>
            </main>
        </div>
    )
}

MatTypeRouterApp.propTypes = {
    params: PropTypes.shape({
        code: PropTypes.string,
        field: PropTypes.string,
    }),
}

export default MatTypeRouterApp